/**
 * Time-of-day greeting keyed by the user's local browser time.
 *  05:00–11:59 → morning
 *  12:00–17:59 → day / afternoon
 *  otherwise   → evening
 * Returns an i18n key under `dashboard.greeting_*`.
 */
export function greetingKey(now = new Date()) {
  const h = now.getHours();
  if (h >= 5 && h < 12) return "dashboard.greeting_morning";
  if (h >= 12 && h < 18) return "dashboard.greeting_day";
  return "dashboard.greeting_evening";
}
